export enum AuditType {
    External,
    Internal,
}
